var map = {
	"./add-oneyuan-bg.svg": "bff9",
	"./add-oneyuan-pointer.svg": "c90b",
	"./add-oneyuan-sanjiao.svg": "9cd9",
	"./add-oneyuan-select.svg": "1210",
	"./agreement-select.svg": "fbb6",
	"./alert.svg": "40ff",
	"./balance_pay.svg": "b553",
	"./baseline.svg": "e2a4",
	"./bless-jinzhu-icon.svg": "e3aa",
	"./bless-vip-icon.svg": "52c2",
	"./blessingSong.svg": "d523",
	"./close.svg": "3ff6",
	"./close_sound.svg": "1747",
	"./control_icon.svg": "f9aa",
	"./countdown-clock.svg": "8976",
	"./delete.svg": "8a04",
	"./duigou.svg": "e5e9",
	"./footer-icon1.svg": "c8f9",
	"./footer-icon2.svg": "9382",
	"./footer-icon3.svg": "d7d5",
	"./footer-icon4.svg": "5208",
	"./general_order_icon.svg": "cb4d",
	"./geshen.svg": "1bdd",
	"./gf_select_icon.svg": "b057",
	"./gm-inform.svg": "ab0d",
	"./gm-search.svg": "edfd",
	"./gm-search_highlight.svg": "5899",
	"./gm_icon.svg": "7fe3",
	"./gm_vip.svg": "46cb",
	"./gold_icon.svg": "7220",
	"./haichang.svg": "7735",
	"./have-ordered.svg": "30ea",
	"./index-singer-icon.svg": "1b8a",
	"./left.svg": "0716",
	"./love.svg": "8f2e",
	"./maiba_icon.svg": "32d4",
	"./maikefeng.svg": "5914",
	"./more.svg": "90d5",
	"./newGift.svg": "9ab2",
	"./no-limit.svg": "1158",
	"./open_sound.svg": "100f",
	"./open_vip.svg": "0a88",
	"./orderSong.svg": "54dd",
	"./order_icon.svg": "9adb",
	"./order_meal.svg": "f786",
	"./pay_not_enough.svg": "ccd3",
	"./pay_not_select.svg": "941b",
	"./pay_selected.svg": "9f6d",
	"./photoBtn.svg": "1250",
	"./play_song.svg": "c764",
	"./recommend.svg": "cf5b",
	"./search.svg": "e38f",
	"./sendgifts.svg": "5db5",
	"./shuaxin.svg": "accf",
	"./square-custom.svg": "4a56",
	"./super_vip.svg": "b7e8",
	"./top_icon.svg": "8b77",
	"./vip.svg": "516d",
	"./vip2.svg": "5aa6",
	"./vipzone-active.svg": "c28d",
	"./vipzone-custom-active.svg": "92b0",
	"./vipzone.svg": "cdc8",
	"./voice.svg": "511c",
	"./wuqu.svg": "501f",
	"./wx_pay.svg": "e00d",
	"./xa_checked.svg": "38df",
	"./xa_unchecked.svg": "472f",
	"./xianshi.svg": "110b",
	"./yinyi.svg": "ebd9",
	"./zhufu_icon.svg": "6aac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9211";